import React from 'react';
import UserMenu from '../user-menu';
import { useSelector } from 'react-redux';
import { TReducerRootState } from 'redux/types';
import { AppBarTitleWrapper } from './index.styled';
import { AppBarStyled } from './index.styled';

const AppBar = () => {
    const title = useSelector<TReducerRootState, string>(
        (state) => state.appBar.title,
    );

    return (
        <AppBarStyled>
            <AppBarTitleWrapper>{title}</AppBarTitleWrapper>
            <UserMenu />
        </AppBarStyled>
    );
};

export default AppBar;
